import { Container, i18n, Table, TableRow } from "@common";
import { useRef, useCallback, useState } from 'react';
import Edit from './edit';
import { adminService } from "@api";
import Preview from "./preview";

const EmailTemplate = () => {

    const tableRef = useRef();
    const [showPanel, setShowPanel] = useState({ show: false });
    const [showPreview, setShowPreview] = useState({ show: false });
    const [selectedItems, setSelectedItems] = useState([]);
    const [onPreviewItems, setOnPreviewItems] = useState([]);

    const columns = [
        { header: i18n.get('CIS_Admin_EmailTemplate_Subject_Entry'), sortable: true, valuePath: 'Subject' },
        { header: i18n.get('CIS_Admin_EmailTemplate_TemplateType_Entry') },
        { header: i18n.get('Common_ModifiedOn_Entry'), sortable: true, valuePath: 'Modified' },
        { header: i18n.get('CIS_Admin_Common_ModifiedBy_Entry') },
    ];

    const onRowEvent = (args) => {
        let rowData = args.rowData;
        setSelectedItems(rowData);
        setShowPanel({ show: true });
    };

    const onLoadData = useCallback((info) => {
        return adminService.emailTemplatePaging(info);
    }, []);

    const reloadTable = useCallback((create, message) => {
        create ?
            tableRef.current.loadFirstPage() :
            tableRef.current.loadCurrentPage();
        setShowPanel({ show: false });
        setSelectedItems([]);
        setOnPreviewItems([]);
        if (message) {
            $$.toast(message);
        }
    }, [tableRef]);

    const onPreview = (formItems) => {
        setShowPreview({ show: true });
        setOnPreviewItems(formItems);
        return false;
    };

    return (
        <Container>
            <Table
                id="table-email-template"
                onLoadData={onLoadData}
                ref={tableRef}
                rowTemplate={TableRowTemp}
                columns={columns}
                onRowEvent={onRowEvent}
            />
            <Edit status={showPanel} item={selectedItems} reloadTable={reloadTable} onPreview={onPreview} />
            <Preview status={showPreview} item={onPreviewItems}></Preview>
        </Container>
    );
};
class TableRowTemp extends TableRow {
    editClick = () => this.dispatch('edit');
    action = () => {
        return [
            { text: i18n.get('Common_Edit_Entry'), icon: 'fia-pen-edit', name: 'edit', tooltip: i18n.get('Common_Edit_Entry'), onClick: this.editClick },
        ];
    };

    render(Row, Cell) {
        const { title, modified, modifiedby, id } = this.props.rowData;
        let templateType = id.substr(0, id.indexOf(':'));
        switch (templateType) {
            case 'OTP':
                templateType = i18n.get('CIS_Admin_EmailTemplate_OTP_Entry');
                break;
            case 'WELCOME':
                templateType = i18n.get('CIS_Admin_EmailTemplate_Welcome_Entry');
                break;
            case 'RESET2FA':
                templateType = i18n.get('CIS_Admin_EmailTemplate_Reset2FA_Entry');
                break;
            case 'RESETPASSWORD':
                templateType = i18n.get('CIS_Admin_EmailTemplate_ResetPassword_Entry');
                break;
            default:
                break;
        }
        return (
            <Row action={this.action}>
                <Cell>{title || i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{templateType}</Cell>
                <Cell>{modified ? $$.date.format(new Date(modified), "dd/MM/yyyy HH:mm:ss") : i18n.get('Common_NA_Entry')}</Cell>
                <Cell>{modifiedby || i18n.get('Common_NA_Entry')}</Cell>
            </ Row>
        );
    }
}

export default EmailTemplate;